export const bgImage = "sakhonnakhon-phattana.jpg";

export const pipesPosition = [
  {
    key: "waterAll",
    src: require(`../../assets/images/pipes/sakhonnakhon-phattana-waterAll.png`),
    status: true,
  },
];

export const metersTextPosition = [
  {
    group: "mainTank",
    title: "ถังส่งน้ำระยะไกล (IN)",
    key: "mainTankIn",
    top: 60.9,
    left: 39,
    deviceId: "4708130201001",
    type: "tank",
    valMeters: [
      { key: "tankInTDS", val: 0, error: 0, type: "TDS" },
      // { key: "tankInEC", val: 0, error: 0, type: "EC" },
    ],
  },
  {
    group: "mainTank",
    title: "ถังส่งน้ำระยะไกล (OUT)",
    key: "mainTankOut",
    top: 60.9,
    left: 64,
    deviceId: "4708130201002",
    type: "tank",
    valMeters: [
      { key: "tankOutTDS", val: 0, error: 0, type: "TDS" },
      // { key: "tankOutEC", val: 0, error: 0, type: "EC" },
    ],
  },
];

export const tanksTextPosition = [
  {
    id: 1,
    group: "middleTank",
    key: "middleTankLeft",
    title: "ระดับน้ำในถังพักน้ำ 1",
    top: 66.5,
    left: 18.5,
    type: "tank",
    deviceId: "4708130200201",
    valTank: { curVol: 100, maxVol: 500 },
    animatePos: {
      top: 65.85,
      left: 16.62,
      width: 0.55,
      height: 6.5,
      maxHeight: 4.25,
      blockWidth: 0.75,
    },
  },
  {
    id: 2,
    group: "middleTank",
    key: "middleTankRight",
    title: "ระดับน้ำในถังพักน้ำ 2",
    top: 66.5,
    left: 81.2,
    type: "tank",
    deviceId: "4708130200201",
    valTank: { curVol: 100, maxVol: 500 },
    animatePos: {
      top: 65.8,
      left: 79.3,
      width: 0.55,
      height: 6.5,
      maxHeight: 4.25,
      blockWidth: 0.75,
    },
  },
  {
    id: 3,
    group: "Tank",
    key: "mainTank",
    title: "ระดับน้ำในหอถังสูง",
    top: 19.75,
    left: 45.75,
    type: "tank",
    deviceId: "4708130200701",
    valTank: { curVol: 100, maxVol: 300 },
    animatePos: {
      top: 19.75,
      left: 44.05,
      width: 0.55,
      height: 6.5,
      maxHeight: 4.25,
      blockWidth: 0.75,
    },
  },
];

export const arrowsPosition = [
  // HOLE_01
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_01_1",
    style: "arrow-blink-lv0",
    left: 9.8,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  // HOLE_02
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_02_1",
    style: "arrow-blink-lv0",
    left: 17.15,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  // HOLE_03
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_03_1",
    style: "arrow-blink-lv0",
    left: 24.5,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  // HOLE_04
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_04_1",
    style: "arrow-blink-lv0",
    left: 31.85,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  // HOLE_05
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_05_1",
    style: "arrow-blink-lv0",
    left: 70.7,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  // HOLE_06
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_06_1",
    style: "arrow-blink-lv0",
    left: 78,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  // HOLE_07
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_07_1",
    style: "arrow-blink-lv0",
    left: 85.4,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  // HOLE_08
  {
    groupId: "arrow_in_left",
    key: "arrow_in_hole_08_1",
    style: "arrow-blink-lv0",
    left: 92.7,
    top: 85.8,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },

  // WATER_IN_LEFT
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_01",
    style: "arrow-blink-lv1",
    left: 12.25,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_02",
    style: "arrow-blink-lv2",
    left: 14.95,
    top: 81.85,
    w: 0.5,
    h: 0.6,
    name: "Up",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_03",
    style: "arrow-blink-lv0",
    left: 17,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_04",
    style: "arrow-blink-lv5",
    left: 19.75,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_05",
    style: "arrow-blink-lv4",
    left: 22,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_06",
    style: "arrow-blink-lv3",
    left: 24.4,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_07",
    style: "arrow-blink-lv2",
    left: 26.7,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_08",
    style: "arrow-blink-lv1",
    left: 29.3,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_in_left",
    key: "arrow_water_in_left_09",
    style: "arrow-blink-lv3",
    left: 14.95,
    top: 77,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },

  // WATER_IN_RIGHT
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_01",
    style: "arrow-blink-lv1",
    left: 73,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_02",
    style: "arrow-blink-lv2",
    left: 75.75,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_03",
    style: "arrow-blink-lv3",
    left: 78,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_04",
    style: "arrow-blink-lv4",
    left: 80.6,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_05",
    style: "arrow-blink-lv5",
    left: 83,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_06",
    style: "arrow-blink-lv1",
    left: 85.3,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_07",
    style: "arrow-blink-lv1",
    left: 90,
    top: 81.85,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_08",
    style: "arrow-blink-lv2",
    left: 87.55,
    top: 81.85,
    w: 0.5,
    h: 0.6,
    name: "Up",
    status: true,
  },
  {
    groupId: "arrow_in_right",
    key: "arrow_water_in_right_09",
    style: "arrow-blink-lv3",
    left: 87.55,
    top: 77,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },

  // WATER_BALANCE
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_01",
    style: "arrow-blink-lv0",
    left: 27.3,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_02",
    style: "arrow-blink-lv1",
    left: 30.25,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_03",
    style: "arrow-blink-lv2",
    left: 33.3,
    top: 76.5,
    w: 0.5,
    h: 0.6,
    name: "Up",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_04",
    style: "arrow-blink-lv1",
    left: 36.25,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_05",
    style: "arrow-blink-lv0",
    left: 39.35,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_06",
    style: "arrow-blink-lv5",
    left: 42.4,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_07",
    style: "arrow-blink-lv4",
    left: 45.5,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_08",
    style: "arrow-blink-lv3",
    left: 48.55,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_09",
    style: "arrow-blink-lv2",
    left: 51.75,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_10",
    style: "arrow-blink-lv1",
    left: 54.75,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_11",
    style: "arrow-blink-lv0",
    left: 57.75,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_12",
    style: "arrow-blink-lv5",
    left: 60.75,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_13",
    style: "arrow-blink-lv4",
    left: 63.9,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_14",
    style: "arrow-blink-lv3",
    left: 67,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_15",
    style: "arrow-blink-lv2",
    left: 70,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_16",
    style: "arrow-blink-lv1",
    left: 73,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_17",
    style: "arrow-blink-lv0",
    left: 75.6,
    top: 76.5,
    w: 0.7,
    h: 0.5,
    name: "Left",
    status: true,
  },
  {
    groupId: "arrow_balance",
    key: "arrow_water_bal_18",
    style: "arrow-blink-lv3",
    left: 33.3,
    top: 73.3,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },

  // WATER_IN_TANK
  {
    groupId: "arrow_in_tank",
    key: "arrow_water_in_tank_01",
    style: "arrow-blink-lv0",
    left: 40,
    top: 69.05,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_tank",
    key: "arrow_water_in_tank_02",
    style: "arrow-blink-lv1",
    left: 42,
    top: 69.05,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_in_tank",
    key: "arrow_water_in_tank_03",
    style: "arrow-blink-lv2",
    left: 44,
    top: 69.05,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },

  // WATER_OUT_TANK
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_01",
    style: "arrow-blink-lv0",
    left: 49.75,
    top: 69.05,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_02",
    style: "arrow-blink-lv1",
    left: 65,
    top: 69.05,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_03",
    style: "arrow-blink-lv2",
    left: 67,
    top: 69.05,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_04",
    style: "arrow-blink-lv3",
    left: 69,
    top: 69.05,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_05",
    style: "arrow-blink-lv4",
    left: 71.25,
    top: 64,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_06",
    style: "arrow-blink-lv5",
    left: 71.25,
    top: 59,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_07",
    style: "arrow-blink-lv0",
    left: 71.25,
    top: 54,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_08",
    style: "arrow-blink-lv1",
    left: 71.25,
    top:49.5,
    w: 0.5,
    h: 0.7,
    name: "Up",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_09",
    style: "arrow-blink-lv2",
    left: 74,
    top: 44.6,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_10",
    style: "arrow-blink-lv3",
    left: 77,
    top: 44.6,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_11",
    style: "arrow-blink-lv4",
    left: 80,
    top: 44.6,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_12",
    style: "arrow-blink-lv5",
    left: 83,
    top: 44.6,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
  {
    groupId: "arrow_out_tank",
    key: "arrow_water_out_tank_13",
    style: "arrow-blink-lv0",
    left: 86,
    top: 44.6,
    w: 0.7,
    h: 0.5,
    name: "Right",
    status: true,
  },
];